exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#apicalls .nav-tabs{height:38px}#apicalls .nav-tabs ul{margin:0;padding:0}#apicalls .nav-tabs li{background:none;margin:0;padding:0}#apicalls table{background:none transparent;border-collapse:collapse;font-size:13px;margin:0;text-align:left;width:100%}#apicalls .period-section{padding:10px 0 0;margin:0;width:50%}#apicalls .period-section .period{position:absolute;width:50px;padding-top:10px;font-size:14px}#apicalls .period-section .selectParent{width:85%;position:relative;float:right}.ir-search-integrations-message{margin-top:10px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/Integrations/ApiCalls.less
 ** module id = 1054
 ** module chunks = 0
 **/